import React from 'react';
import { Typography, TypographyProps } from '@mui/material';
import { useGetEnvironnementQuery } from '@services/configApi';

interface VersionDisplayProps {
  typographyProps?: TypographyProps;
}

const VersionDisplay = React.memo(function VersionDisplay({ 
  typographyProps 
}: Readonly<VersionDisplayProps>) {
  const { data: environnement } = useGetEnvironnementQuery();

  if (!environnement?.version) {
    return null;
  }

  // Strip build metadata (git hash after +) for cleaner display
  const displayVersion = environnement.version.split('+')[0];

  return (
    <Typography
      variant="caption"
      sx={{
        color: 'text.secondary',
        fontSize: '0.75rem',
        ...typographyProps?.sx,
      }}
      {...typographyProps}
    >
      {displayVersion}
    </Typography>
  );
});

export default VersionDisplay;

